<template>
  <div id="app">
    <RouterView></RouterView>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
    
  },
};
</script>

<style>
  #app {
    height: 100%;
  }
</style>